import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Provider as UploodsProvider } from 'uploods'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { CssBaseline } from '@material-ui/core'
import { StylesProvider } from '@material-ui/styles'
import { SnackbarProvider } from '@seasonedsoftware/ui'
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { CookiesProvider } from 'react-cookie'
import amplitude from 'amplitude-js'
import { Experiment } from '@amplitude/experiment-js-client'

import { AmplitudeProvider } from 'amplitude/AmplitudeContext'

import theme from '../theme'
import CustomCroodsProvider from './CroodsProvider'

amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_API_KEY, null, {
  includeGclid: true,
  includeReferrer: true,
  includeUtm: true,
})

const gtmParams = {
  id: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
  environment: {
    gtm_auth: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ENVIRONMENT_AUTH,
    gtm_preview: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ENVIRONMENT_PREVIEW,
  },
}

const Providers = ({ children }) => {
  const [experimentInstance, setExperimentInstance] = useState(null)

  useEffect(() => {
    const deployKey = process.env.REACT_APP_AMPLITUDE_EXPERIMENT_DEPLOY_KEY
    const debug = process.env.NODE_ENV === 'development'
    const configs = {
      automaticFetchOnAmplitudeIdentityChange: true,
      fetchOnStart: true,
      debug,
    }

    if (deployKey) {
      const experiment = Experiment.initializeWithAmplitudeAnalytics(
        deployKey,
        configs,
      )

      experiment
        .start()
        .catch(() => null)
        .then(() => setExperimentInstance(experiment))
    }
  }, [])

  return (
    <CookiesProvider>
      <CustomCroodsProvider>
        <GTMProvider state={gtmParams}>
          <AmplitudeProvider
            analytics={amplitude}
            experiment={experimentInstance}
          >
            <MuiThemeProvider theme={theme}>
              <SnackbarProvider>
                <StylesProvider>
                  <UploodsProvider
                    storageBucket={
                      process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
                    }
                    apiKey={process.env.REACT_APP_FIREBASE_API_KEY}
                    autoUpload
                  >
                    <CssBaseline />
                    {children}
                  </UploodsProvider>
                </StylesProvider>
              </SnackbarProvider>
            </MuiThemeProvider>
          </AmplitudeProvider>
        </GTMProvider>
      </CustomCroodsProvider>
    </CookiesProvider>
  )
}

Providers.propTypes = {
  children: PropTypes.element.isRequired,
}

export default Providers
